import React from "react";
import { Alert, Box, ButtonWithAction } from "@thecb/components";

const RetryAlert = ({ heading, text, onRetry, isRetrying = false }) => (
  <Alert
    heading={heading}
    text={text}
    variant="error"
    showQuitLink={false}
    ariaRole="alert"
  >
    <Box padding="0.5rem 0 0">
      <ButtonWithAction
        variant="secondary"
        text="Try again"
        action={onRetry}
        isLoading={isRetrying}
        dataQa="Try again"
      />
    </Box>
  </Alert>
);

export default RetryAlert;
